import styled from '@emotion/styled';
import tw from 'twin.macro';

import { CreateAnnualReport, CreateMonthlyReport } from '../../models';
import { useReportStore } from '../../providers';
import { Table } from '../Table';

const HorizontalRule = styled.hr`
  ${tw`my-6 border-neutral-700`}
`;

enum TableLabels {
  monthlyRevenues = 'Monthly Revenue',
  monthlyExpenses = 'Monthly Expenses',
  monthlyCashFlow = 'Monthly Cash Flow',
  annualRevenues = 'Annual Revenue',
  annualExpenses = 'Annual Expenses',
  annualCashFlow = 'Annual Cash Flow',
  homeValues = 'Home Value',
  principalsRemaining = 'Principal Remaining',
  equities = 'Equity',
  equityLessCashInvested = 'Equity Less Cash',
  cumulativeCashFlowForLoanTerm = 'Cumulative Cash Flow',
  profitsAtSale = 'Profits At Sale',
  totalReturns = 'Total Return',
  cashOnCashReturn = 'Cash On Cash Return',
  simpleROI = 'Simple ROI',
  capRate = 'Cap Rate'
}

type ReportTableProps = {
  monthly: CreateMonthlyReport | undefined;
  yearly: CreateAnnualReport | undefined;
};

export function ReportTable({ monthly, yearly }: ReportTableProps) {
  const { purchase } = useReportStore();

  const monthHeaders: string[] = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  const termHeaders: string[] = Array((purchase?.term || 0) + 1)
    .fill(null)
    .map((_, i) => String(i === 0 ? '' : i));

  return (
    <>
      {monthly ? (
        <Table
          data={monthly}
          headers={monthHeaders}
          title={'Monthly Information'}
          labels={TableLabels}
        />
      ) : null}
      <HorizontalRule />
      {yearly ? (
        <Table
          data={yearly}
          headers={termHeaders}
          title={'Annual Information'}
          labels={TableLabels}
        />
      ) : null}
    </>
  );
}

export default ReportTable;
